import { render } from "./SandwichMenuIcon.vue?vue&type=template&id=53f9066a&scoped=true"
import script from "./SandwichMenuIcon.vue?vue&type=script&lang=js"
export * from "./SandwichMenuIcon.vue?vue&type=script&lang=js"

import "./SandwichMenuIcon.vue?vue&type=style&index=0&id=53f9066a&lang=scss&scoped=true"

import exportComponent from "/Users/gisselareyes/Documents/Github/gisse-la/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f9066a"]])

export default __exports__